import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
    <h1 style={{ fontSize: 64, color: '#1d4e89' }}>404</h1>
    <p>找不到這個頁面。</p>
    <Link to="/">回到首頁</Link>
  </div>
);

export default NotFound;
